import React from 'react';

interface AppMetaBadgeProps {
  label: string;
  iconUrl?: string | null;
}

const AppMetaBadge: React.FC<AppMetaBadgeProps> = ({ label, iconUrl }) => (
  <div className="d-flex align-items-center" title={label}>
    {iconUrl ? (
      <img src={iconUrl} alt="" width={20} height={20} className="rounded me-2" />
    ) : (
      <i className="ri-smartphone-line text-info me-2"></i>
    )}
    <span className="fw-medium text-truncate" style={{ maxWidth: '100px' }}>{label}</span>
    <span className="badge bg-secondary bg-opacity-10 text-secondary ms-2" style={{ fontSize: '0.65rem' }}>App</span>
  </div>
);

export default AppMetaBadge;
